var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ODRendererComponentType } from '@mdpp/od-belt';
import React from 'react';
import { ODBooleanRenderer } from './variants/ODBooleanRenderer';
import { ODDateTimeRenderer } from './variants/ODDateTimeRenderer';
import { ODEnumRenderer } from './variants/ODEnumRenderer';
import { ODImageFileRenderer } from './variants/ODImageFileRenderer';
import { ODStringRenderer } from './variants/ODStringRenderer';
export var ODRendererFactory = function (_props) {
    var def = _props.def, props = __rest(_props, ["def"]);
    switch (def.component) {
        case ODRendererComponentType.BooleanRenderer:
            return React.createElement(ODBooleanRenderer, __assign({}, props, def));
        case ODRendererComponentType.StringRenderer:
            return React.createElement(ODStringRenderer, __assign({}, props, def));
        case ODRendererComponentType.DateTimeRenderer:
            return React.createElement(ODDateTimeRenderer, __assign({}, props, def));
        case ODRendererComponentType.EnumRenderer:
            return React.createElement(ODEnumRenderer, __assign({}, props, def));
        case ODRendererComponentType.NoRenderer:
            // tslint:disable-next-line:no-console
            console.warn("NoRenderer is used.");
            return React.createElement("div", null, "NoRender");
        case ODRendererComponentType.ImageFileRenderer:
            return React.createElement(ODImageFileRenderer, __assign({}, props, def));
    }
};
//# sourceMappingURL=ODRendererFactory.js.map